@switch (stateValue) {
  @case ('loaded') {
    <span class="loaded">&ZeroWidthSpace;</span>
  }

  @case ('saving') {
    <span class="saving"><ftr-loader [iconOnly]="true" [inline]="false" [isLoading]="true"></ftr-loader>Saving</span>
  }

  @case ('saved') {
    <span class="saved"><ftr-icon size="Small" align="Middle" icon="Done"></ftr-icon>Saved</span>
  }

  <!-- Error case  -->
  @default {
    <span class="error"
      ><span>{{ stateValue.errorMessage }}</span>
      @if (stateValue.showRetry) {
        <a (click)="retry.emit()">Retry</a>
      }
      @if (stateValue.showUndo) {
        <a (click)="undo.emit()">Undo</a>
      }
    </span>
  }
}
